import { TechItem } from '@portalCommon/constants';
import classnames from 'classnames/bind';
import HorizontalVideo from '../HorizontalVideo';
import styles from './index.module.less';

const cx = classnames.bind(styles);

export const TechList = ({ list }: { list: TechItem[] }) => {
  return (
    <div className={cx('tech')}>
      {list.map((item, idx) =>
        item.video ? (
          <HorizontalVideo
            key={item.title}
            videoPosition={idx ? 'right' : 'left'}
            bgUrl={item.bg}
            src={item.video}
            title={item.title}
            text={item.brief}
            poster={item.image}
          />
        ) : (
          <div
            key={item.title}
            className={cx('tech-item', idx % 2 ? 'right' : 'left')}
            style={{ backgroundImage: `url(${item.bg})` }}>
            {idx % 2 ? (
              <>
                <div className={cx('tech-item-side')}>
                  <div className={cx('title')}>{item.title}</div>
                  <div className={cx('brief')}>{item.brief}</div>
                </div>
                <img className={cx('tech-item-image', 'right')} src={item.image} alt="" />
              </>
            ) : (
              <>
                <img className={cx('tech-item-image', 'left')} src={item.image} alt="" />
                <div className={cx('tech-item-side')}>
                  <div className={cx('title')}>{item.title}</div>
                  <div className={cx('brief')}>{item.brief}</div>
                </div>
              </>
            )}
          </div>
        ),
      )}
    </div>
  );
};
